import { render, staticRenderFns } from "./average.vue?vue&type=template&id=4d46f842"
import script from "./average.vue?vue&type=script&lang=js"
export * from "./average.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports